import React, { forwardRef } from 'react';
import type { IconButtonProps } from '@atlaskit/button/new';
import SprintIcon from '@atlaskit/icon/core/sprint';
import SprintIconOld from '@atlaskit/icon/glyph/sprint';
import type { TriggerProps } from '@atlaskit/popup';
import { ThemedIconButton } from '@atlassian/jira-project-theme-components/src/ui/themed-button-new/ThemedButtonNew.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';

import messages from './messages.tsx';

const TOOLTIP_OPTIONS: IconButtonProps['tooltip'] = {
	hideTooltipOnClick: true,
};

export type Props = Partial<Omit<TriggerProps, 'ref'>> &
	Pick<IconButtonProps, 'isSelected' | 'onClick' | 'isDisabled' | 'analyticsContext'>;

const SprintDetailsTriggerButton = forwardRef(
	(extraProps: Props, ref: React.Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();
		const renderIcon = () => (
			<SprintIcon
				LEGACY_fallbackIcon={SprintIconOld}
				LEGACY_size="small"
				label={fg('tanuki_a11y_q4') ? '' : formatMessage(messages.tooltip)}
			/>
		);
		return (
			<ThemedIconButton
				ref={ref}
				icon={renderIcon}
				label={formatMessage(messages.tooltip)}
				isTooltipDisabled={false}
				tooltip={TOOLTIP_OPTIONS}
				testId="software-board.header.sprint-controls.sprint-details.trigger-button.icon-button"
				{...extraProps}
			/>
		);
	},
);

export default SprintDetailsTriggerButton;
